import styled, {} from "styled-components";

export const LogoContainer = styled.header `
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
  }
`;